import * as React from 'react';
import { connect } from 'react-redux';
import './ForgotPassword.scss';
import { Utils } from '@src/utils/Utils';
import { default as Button, IButtonType } from '@src/components/button/Button';
import { default as Input } from '@src/components/form/input/Input';
import SmallInfo from '@src/components/small-info/SmallInfo';
import InnerFooterWrap from '@src/components/inner-footer-wrap/InnerFooterWrap';
import InnerUiWrap from '@src/components/inner-ui-wrap/InnerUiWrap';
import { AppActions } from '@src/actions/AppActions';
import { __ } from '@src/utils/i18Abstract';

interface IReduxState {}

interface IReduxActions {
    resetPassword: (username: string) => void;
}

interface IState {
    username: string;
    isValid: boolean;
}

type IAllProps = IReduxState & IReduxActions;

class ForgotPassword extends React.Component<IAllProps, IState> {
    state: IState = {
        username: '',
        isValid: true,
    };

    render() {
        const { resetPassword } = this.props;
        const { username, isValid } = this.state;

        return (
            <div className="ForgotPassword-wrap">
                <form
                    onSubmit={e => {
                        e.preventDefault();

                        const trimmedVal = Utils.removeWhitespace(username);
                        let valid: boolean = true;

                        if (
                            !isNaN(Number(trimmedVal)) &&
                            trimmedVal.length >= 1
                        ) {
                            valid = trimmedVal.length === 8;
                            this.setState({ isValid: valid });
                        } else {
                            valid = Boolean(trimmedVal.length);
                        }

                        if (!valid) {
                            return;
                        }

                        resetPassword(username);
                    }}>
                    <InnerUiWrap>
                        <Input
                            name="number"
                            noBottomMargin
                            label={__('inputPhoneOrEmail')}
                            hasError={!isValid}
                            errorLabel={__('warningProvideValidLVPhone')}
                            value={username}
                            onChange={value => {
                                const trimmedVal = Utils.removeWhitespace(
                                    value,
                                );

                                // Must be a number so check if valid LV phone number
                                if (!isNaN(Number(trimmedVal))) {
                                    if (trimmedVal.length > 8) {
                                        return;
                                    }
                                }

                                this.setState({
                                    username: trimmedVal,
                                    isValid: true,
                                });
                            }}
                        />
                        <SmallInfo
                            alignLeft
                            body={__('recoverPasswordPrivate')}
                        />
                        <SmallInfo
                            alignLeft
                            body={__('recoverPasswordBusiness')}
                        />
                    </InnerUiWrap>

                    <InnerFooterWrap>
                        <Button
                            fat
                            fullWidth
                            title={__('buttonResetPassword')}
                            type={IButtonType.submit}
                        />

                        <SmallInfo body={__('legalNewPassword')} />
                    </InnerFooterWrap>
                </form>
            </div>
        );
    }
}

const mapStateToProps = (state: any): IReduxState => {
    return {};
};

const mapDispatchToProps = (dispatch: any): IReduxActions => {
    return {
        resetPassword: phoneNumber =>
            dispatch(AppActions.changePin(phoneNumber, true)),
    };
};

export default connect<IReduxState, IReduxActions, null>(
    mapStateToProps,
    mapDispatchToProps,
)(ForgotPassword);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/login-overlay/login-tab/forgot-password/ForgotPassword.tsx